import { HomeDashboard } from "@/features/home/home-dashboard"

/** `/w/$ws`: the workspace home (settings wave §3.4). */
export function WorkspaceHome() {
  return <HomeDashboard />
}
